import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { getQuestionnairesOverview } from "../../actions/Questionnaires";
import Access from "../../../../components/Access";
import Page from "../../../../components/Page";
import ExecutableQuestionnaires from "../../components/ExecutableQuestionnaires";
import OrderableQuestionnaires from "../../components/OrderableQuestionnaires";
import { translations } from "../../../../config";

const mapStateToProps = ( state ) =>
{
	return {
		orderableQuestionnaires: state.orderableQuestionnaires,
		questionnairesOverview: state.questionnairesOverview,
		user: state.user
	};
};

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		getQuestionnairesOverview: () =>
		{
			dispatch( getQuestionnairesOverview() );
		}
	};
};

/**
 * Fragebogenkomponente der GUI
 */
class LandingPage extends React.Component
{
	componentDidMount()
	{
		if ( Access.isPermitted( this.props.user, [ "select_questionnaires" ] ) )
		{
			this.props.getQuestionnairesOverview();
		}
		
	} // function componentDidMount()
	
	static renderPage( questionnaires )
	{
		return questionnaires && <Page title={`Herzlich Willkommen bei ${translations.de_DE.words.appName}!`} pageUrl={"/"}>
			<div className={"col s12"}>
				
				{questionnaires.length > 0 && <OrderableQuestionnaires questionnaires={questionnaires} basicPriceInfo/>}
				
				<h4>Sparen Sie jede Menge Zeit und Geld bei der Richtlinienrecherche!</h4>
				<p>Imera hilft ihnen schnell und kostengünstig auf dem Weg zur CE-Konformität Ihres Erzeugnisses.</p>
				<p>Die Imera sind Einstufungsassistenten, die Sie mittels smarter Workflows, sicher und rechtskonform bei der Durchführung der gesetzlich vorgeschriebenen
					Richtlinienrecherche unterstützen. Ohne Sachverständigenkosten führen Sie selbständig die Einstufung für Ihr Erzeugnis durch.</p>
				<p>Hier erfahren Sie mehr zur <Link to={"/richtlinienrecherche"}>Richtlinienrecherche</Link> im CE-Konformitätsprozess.</p>
				
				<div className={"col s12 spacer"}/>
				
				<Link to={translations.de_DE.routes.registration}>
					<h3 className={"col m8 unset-padding margin-bottom"}>Eröffnen Sie jetzt Ihr {translations.de_DE.words.appName} Kundenkonto.</h3>
					<div className={"col m4 tRight unset-padding"}>
						<div className={"btn"}>Los geht´s!</div>
					</div>
				</Link>
				
				<div className={"col s12 spacer"}/>
			</div>
		</Page>;
		
	} // function renderLandingPage(...)
	
	static renderLoggedInPage( questionnaires )
	{
		return questionnaires && <Page title={"Einstufungsassistenten zur Richtlinienrecherche"} pageUrl={"/"}>
			<div className={"col s12"}>
				<ExecutableQuestionnaires questionnaires={questionnaires}/>
			</div>
		</Page>;
		
	} // function renderLoggedInLandingPage(...)
	
	render()
	{
		const { orderableQuestionnaires, questionnairesOverview, user } = { ...this.props };
		
		// Dashboard für RollenAdmin
		if ( Access.isPermitted( user, [ "get_roles" ], true ) )
		{
			return <Page title={"Dashboard"} pageUrl={"/"}>
				<div className={"col s12"}>
					<p/>
				</div>
			</Page>;
		}
		
		// Dashboard für FakturaAdmin
		if ( Access.isPermitted( user, [ "get_articles" ], true ) )
		{
			return <Page title={"Dashboard"} pageUrl={"/"}>
				<div className={"col s12"}>
					<p/>
				</div>
			</Page>;
		}
		
		return <Access permissions={[ "guest_user_permissions" ]}
		               errorContent={
			               <Access permissions={[ "user_permissions" ]}>
				               {LandingPage.renderLoggedInPage( questionnairesOverview )}
			               </Access>
		               }>
			{LandingPage.renderPage( orderableQuestionnaires )}
		</Access>;
		
	} // function render()
	
} // class

LandingPage = connect(
	mapStateToProps,
	mapDispatchToProps
)( LandingPage );

export default LandingPage;
